import React from "react";
import CredentialPicker from "../../../../../../../auth/CredentialPicker";
import WizardCustomHeaderAuth from "./WizardCustomHeaderAuth";
import { CredentialsType } from "../../../../../../../common/interfaces/credentials/Credentials";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentWizardData } from "../../../../../../../redux/actions/wizardActions";
import { Flex } from "@atlaskit/primitives";
import SectionMessage from "@atlaskit/section-message";

const NewOrExistingCustomHeaderAuth = ({ info }) => {
  const currentData = useSelector((state) => state.wizard.currentData);
  const dispatch = useDispatch();

  // Function to handle radio button change
  const handleRadioChange = (e) => {
    const updatedData = {
      ...currentData,
      selectedOktaAuthOption: e.target.value,
    };
    dispatch(setCurrentWizardData(updatedData));
  };

  // Function to update Redux state based on the selected option
  const onChangeCredentialPicker = (value) => {
    const updatedData = {
      ...currentData,
      oktaCredential: value,
    };
    dispatch(setCurrentWizardData(updatedData));
  };

  return (
    <div>
      <br />
      <SectionMessage title="Information" appearance="info">
        <p>{info}</p>
      </SectionMessage>
      <br />
      <Flex gap="space.100" justifyContent={100}>
        <div>
          <label>
            <input
              type="radio"
              value="CredentialPicker"
              checked={currentData?.selectedOktaAuthOption === "CredentialPicker"}
              onChange={handleRadioChange}
            />
            Existing Credential
          </label>
          <br />
          <label>
            <input
              type="radio"
              value="WizardHeaderAuth"
              checked={currentData?.selectedOktaAuthOption === "WizardHeaderAuth"}
              onChange={handleRadioChange}
            />
            New Credential
          </label>
        </div>
        <div className="wizard-basic-cred">
          {(currentData?.selectedOktaAuthOption === "CredentialPicker" ||
            !currentData?.selectedOktaAuthOption) && (
            <>
              Stored Credentials:
              <CredentialPicker
                onSelect={onChangeCredentialPicker}
                value={currentData?.oktaCredential?.value}
                showOnlyCredType={CredentialsType.CUSTOM_HEADER}
              />
              Select a stored token credential.
            </>
          )}
          {currentData?.selectedOktaAuthOption === "WizardHeaderAuth" && (
            <WizardCustomHeaderAuth />
          )}
        </div>
      </Flex>
    </div>
  );
};

export default NewOrExistingCustomHeaderAuth;
